export default __webpack_public_path__ + "static/blackness-full-bloom-9f87ae3af409c1361ec900bc4b589dc6.jpg";